export enum XpassProduct {
  STRESS_FREE = 1,
  GOVT_FEE = 2,
  CONCIERGE = 3
}
